import SEOArticlePage from "@/components/feature/SEOArticlePage";
import { articleContents } from "@/mocks/seo-article-content";

export default function HipobuyDebutant() {
  return <SEOArticlePage article={articleContents["hipobuy-debutant"]} />;
}